import { Types } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { WFHPlaylistTop } from './types'

/**
 * WFH top playlist reducer
 */
const wfhPlaylistTop = buildAsyncStatReducer({
    key: Metrics.WFH_PLAYLIST_TOP,
    types: {
        request: Types.DASHBOARD_WFH_PLAYLIST_TOP.request,
        success: Types.DASHBOARD_WFH_PLAYLIST_TOP.success,
        failure: Types.DASHBOARD_WFH_PLAYLIST_TOP.failure,
    },
    transform: (state, { payload = [] }): WFHPlaylistTop => {
        const { content, count } = payload[0] || {}
        return { id: content, name: content, icon: null, total: count }
    },
})

export default wfhPlaylistTop
